<template lang="html">
  <div class="flex flex-col">
    <TgBanner />

    <CatalogSection class="w-full max-w-480 sm:m-auto" />

    <div class="main-catalog-container w-full sm:m-auto sm:max-w-480">
      <CatalogContent
        class="w-full pt-16 sm:m-auto"
        :selected-category="selectedCategory"
        @update:selected-category="onCategorySelect"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import CatalogContent from '#Products/components/Catalog/CatalogContent.vue'
import CatalogSection from '#Products/components/Info/CatalogSection.vue'
import type { CategoryDto } from '#Products/models/Pim/CategoryDto'
import TgBanner from '~/app/components/Banner/TgBanner.vue'

definePageMeta({
  name: 'ProductsCatalog',
  layoutContainer: 'full',
})

const route = useRoute()
const { routing } = useProducts()
const { all } = await useCategories()

const slug = computed(() => route.params.category as string | undefined)

const selectedCategory = computed<CategoryDto | undefined>(() => {
  if (!slug.value) return undefined
  const id = routing.extractIdFromSlug(slug.value)
  return all.value?.[id] as CategoryDto | undefined
})

// ЧПУ категории — на первом рендере (SSR): 404 для несуществующей категории,
// 301 с «неправильного» слага на канонический (дубль-контент)
if (slug.value) {
  if (!selectedCategory.value) {
    throw createError({ statusCode: 404, statusMessage: 'Category not found' })
  }
  const canonicalSlug = routing.getCategorySlug(selectedCategory.value)
  if (slug.value !== canonicalSlug) {
    await navigateTo(routing.getCatalog(selectedCategory.value).route, {
      redirectCode: 301,
      replace: true,
    })
  }
}

useCategorySeo(selectedCategory, all)

function onCategorySelect(category?: CategoryDto) {
  navigateTo(
    category ? routing.getCatalog(category).route : routing.getCatalog().route,
    { replace: true },
  )
}
</script>

<style lang="css" scoped>
.main-catalog-container {
  background:
    url('/catalog/brand/patternLeft.svg') top left / 40% repeat-y,
    url('/catalog/brand/patternRight.svg') top right / 40% repeat-y;
}
</style>
